export { default } from "./RightArrow";
